/*                                          */
import { hydrate_node, hydrating, set_hydrate_node, set_hydrating } from '../hydration.js';
import { create_text, get_first_child, get_next_sibling } from '../operations.js';
import { block } from '../../reactivity/effects.js';
import { HEAD_EFFECT } from '#client/constants';
import { HYDRATION_START } from '../../../../constants.js';

/**
 *
 */
let head_anchor;

export function reset_head_anchor() {
	head_anchor = undefined;
}

/**
 *
 *
 */
export function head(render_fn) {
	/*                                                                                                         */
	/*                                                                              */
	let previous_hydrate_node = null;
	let was_hydrating = hydrating;

	/*                         */
	var anchor;

	if (hydrating) {
		previous_hydrate_node = hydrate_node;

		/*                                                                                                                */
		if (head_anchor === undefined) {
			head_anchor = /*                       */ (get_first_child(document.head));
		}

		while (
			head_anchor !== null &&
			(head_anchor.nodeType !== 8 || /*                  */ (head_anchor).data !== HYDRATION_START)
		) {
			head_anchor = /*                       */ (get_next_sibling(head_anchor));
		}

		/*                                                                            */
		/*                                                 */
		if (head_anchor === null) {
			set_hydrating(false);
		} else {
			head_anchor = set_hydrate_node(/*                       */ (get_next_sibling(head_anchor)));
		}
	}

	if (!hydrating) {
		anchor = document.head.appendChild(create_text());
	}

	try {
		block(() => render_fn(anchor), HEAD_EFFECT);
	} finally {
		if (was_hydrating) {
			set_hydrating(true);
			head_anchor = hydrate_node; /*                                                   */
			set_hydrate_node(/*                       */ (previous_hydrate_node));
		}
	}
}
